import { useCustom, useApiUrl } from "@refinedev/core";
import type { UnifiedHistoryFilters } from "../types/events";

interface UnifiedHistoryItem {
  id: number;
  eventType: "alert" | "journey" | "forbidden_zone";
  timestamp: string;
  isActive: boolean;
  userName: string;
  userEmail: string;
  latitude: number | null;
  longitude: number | null;
  data: Record<string, unknown>;
}

interface UnifiedHistoryResponse {
  data: UnifiedHistoryItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export function useUnifiedHistory(
  filters: UnifiedHistoryFilters,
  page: number = 1,
  limit: number = 10,
) {
  const apiUrl = useApiUrl();

  const query: Record<string, string | number | boolean> = {
    page,
    limit,
  };

  if (filters.search) query.search = filters.search;
  if (filters.eventType) query.eventType = filters.eventType;
  if (filters.dateFrom) query.dateFrom = filters.dateFrom;
  if (filters.dateTo) query.dateTo = filters.dateTo;
  if (filters.hideActive !== undefined) query.hideActive = filters.hideActive;

  const result = useCustom<UnifiedHistoryResponse>({
    url: `${apiUrl}/history`,
    method: "get",
    config: { query },
    queryOptions: {
      queryKey: ["unified-history", filters, page, limit],
      keepPreviousData: true,
    },
  });

  const responseData = result.data?.data;

  return {
    data: responseData?.data ?? [],
    total: responseData?.total ?? 0,
    page: responseData?.page ?? page,
    totalPages: responseData?.totalPages ?? 0,
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    refetch: result.refetch,
  };
}

export type { UnifiedHistoryItem, UnifiedHistoryResponse };
